import { CSSProperties } from "react";
import { useStyles } from "./LoadingScreen.style";
import { StaticImage } from "../../core/StaticImage/StaticImage";
import Logo from "../../../assets/icons/logo_onmo+_1x.webp";
import Logo2x from "../../../assets/icons/logo_onmo+_2x.webp";
import Logo3x from "../../../assets/icons/logo_onmo+_3x.webp";

import LogoIconTv from "../../../assets/icons/logo_onmo+_tv.webp";
import { isTV } from "../../../utils/platform";
import { useTranslation } from "react-i18next";

const visuallyHidden: CSSProperties = {
  position: "absolute",
  width: 1,
  height: 1,
  overflow: "hidden",
  clip: "rect(0 0 0 0)",
  whiteSpace: "nowrap",
};

export const LoadingScreen = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.root} role="status">
      <span style={visuallyHidden}>{t("LoadingScreen_Loading")}</span>
      {isTV ? (
        <StaticImage src={LogoIconTv} alt="ONMO+" className={classes.logoTv} />
      ) : (
        <StaticImage
          src={Logo}
          src2x={Logo2x}
          src3x={Logo3x}
          alt="ONMO+"
          className={classes.logo}
        />
      )}
    </div>
  );
};
